import { render, staticRenderFns } from "./hk5.vue?vue&type=template&id=198d55b0"
import script from "./hk5.vue?vue&type=script&lang=js"
export * from "./hk5.vue?vue&type=script&lang=js"
import style0 from "./hk5.vue?vue&type=style&index=0&id=198d55b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports